import { render } from "./xiangmu_data.vue?vue&type=template&id=29825c3d&scoped=true"
import script from "./xiangmu_data.vue?vue&type=script&lang=js"
export * from "./xiangmu_data.vue?vue&type=script&lang=js"

import "./xiangmu_data.vue?vue&type=style&index=0&id=29825c3d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29825c3d"]])

export default __exports__